import logo from '@/packages/components/base/qrcode/src/assets/img/logo.png'

/**
 * 组件信息
 */
export const info = {
  name: 'xy-qrcode', // 组件名
  type: 'component-base', // 组件类型
  label: '二维码组件', // 组件label
  icon: 'icon-xy-qr', // 组件图标
  defaultWidth: 450, // 组件默认宽度
  defaultHeight: 450 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  // 文本内容
  content: { type: String, default: 'hello world!' },
  width: { type: String, default: '400' },
  logo: { type: String, default: logo },
  element: {
    type: Object,
    default: () => ({
      // 组件名称
      name: '',
      // 组件类型
      type: '',
      // 组件id
      uuid: '',
      // 隐藏
      hiden: false,
      // 动画
      animations: [],
      // 组件样式
      style: {},
      // 组件数据
      data: {},
      // 多语言
      languages: [],
      // 数据源
      dataSource: {},
      // 事件
      events: []
    })
  }
}

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-input', // 表单组件
    label: '二维码内容', // 表单名称
    propKey: 'content', // 表单model字段名称
    isLanguage: true, // 是否可多语言配置
    isActivityData: true // 是否为动态数据
  },
  {
    type: 'xy-form-upload-image', // 表单组件
    label: 'Logo', // 表单名称
    propKey: 'logo', // 表单model字段名称
    isLanguage: true, // 是否可多语言配置
    isActivityData: true // 是否为动态数据
  }
]
